import React from "react";
import "./Latest_nft.css";
import largre_nft from "../Assets/large_nft.png";
import vip from "../Assets/vip_star.png";
import eth_yellow from "../Assets/eth_yellow.png";
import thor from "../Assets/thor.png";
import { FaMinus } from "react-icons/fa";
import { FaPlus } from "react-icons/fa6";
import NFT_video from "../NFT_video/NFT_video";
import story1 from "../Assets/11.jpg";
import story2 from "../Assets/12.jpg";
import story3 from "../Assets/13.jpg";
import story4 from "../Assets/14.jpg";
import story5 from "../Assets/15.jpg";
import story6 from "../Assets/16.jpg";
import story7 from "../Assets/17.jpg";
import story8 from "../Assets/19.jpg";
import story9 from "../Assets/20.jpg";
import story10 from "../Assets/21.jpg";
import story11 from "../Assets/22.jpg";
import nft1 from "../Assets/1.mp4";
import nft2 from "../Assets/2.mp4";
import nft3 from "../Assets/3.mp4";
import nft4 from "../Assets/4.mp4";
import nft5 from "../Assets/5.mp4";
import nft6 from "../Assets/6.mp4";
import nft7 from "../Assets/7.mp4";
import nft8 from "../Assets/8.mp4";
import nft9 from "../Assets/9.mp4";
import nft10 from "../Assets/10.mp4";

export default function Latest_nft() {
  return (
    <div className="lastest_nft_page" id="NFT">
      <div className="overlay"></div>
      <div className="container">
        <h1 className="nft_head z_upper_full position-relative">
          WING P Collection
        </h1>
        <div className="collection-subtitle text-center mb-4">
          <p className="subtitle-text">UNIQUE SELLING - REVOLUTIONIZING ATHLETIC FASHION</p>
          <p className="subtitle-description">Where style and sustainability seamlessly intertwine</p>
        </div>
        
        {/* First row - Big card + 1 NFT card */}
        <div className="row my-5">
          <div className="col-lg-8 col-md-8 col-sm-12 col-12 z_upper_full">
            <div className="nft_large_box">
              <div className="row g-0">
                <div className="col-4">
                  <img src={story1} className="largrknf story-image" alt="WING P Story 1" />
                </div>
                <div className="col-4">
                  <img src={story2} className="largrknf story-image" alt="WING P Story 2" />
                </div>
                <div className="col-4">
                  <img src={story3} className="largrknf story-image" alt="WING P Story 3" />
                </div>
              </div>

              <div className="content_nft">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex gap-2 align-items-center">
                    <h6 className="card_head mb-0 robo_font">WING P</h6>
                    <img src={vip} alt="" />
                  </div>
                  <div className="">
                    <p className="mb-0 d-flex price_tag robo_font">
                      Price:{" "}
                      <span className="price_ineth">
                        <img src={eth_yellow} alt="" /> $150
                      </span>
                    </p>
                  </div>
                </div>
                <p className="minnted  mt-2 robo_font">Minted: 0/1000</p>
                <div className="row justify-content-between my-3">
                  <div className="col-md-8 ">
                    <p className="mint_text mb-0 robo_font">
                      You are not just buying a shoe. You are buying a piece of a dream. 
                      The WING P - where athletic performance meets aerodynamic artistry.{" "}
                    </p>
                  </div>
                  <div className="col-md-4 text-end">
                    <button className="mint_nft_btn robo_font" disabled={true} >
                      Mint NFT
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12 col-12 z_upper_full">
            <NFT_video video_url={nft1} nft_name="WING P #1"/>
          </div>
        </div>

        {/* NFT Collection Grid - 3 cards per row */}
        <div className="nft_collection_grid">
          <div className="row g-4">
            {/* Second row - 3 cards */}
            <div className="col-lg-4 col-md-4 col-sm-6 col-12">
              <NFT_video video_url={nft2} nft_name="WING P #2"/>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6 col-12">
              <NFT_video video_url={nft3} nft_name="WING P #3"/>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6 col-12">
              <NFT_video video_url={nft4} nft_name="WING P #4"/>
            </div>
            
            {/* Third row - 3 cards */}
            <div className="col-lg-4 col-md-4 col-sm-6 col-12">
              <NFT_video video_url={nft5} nft_name="WING P #5"/>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6 col-12">
              <NFT_video video_url={nft6} nft_name="WING P #6"/>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6 col-12">
              <NFT_video video_url={nft7} nft_name="WING P #7"/>
            </div>
            
            {/* Fourth row - 3 cards */}
            <div className="col-lg-4 col-md-4 col-sm-6 col-12">
              <NFT_video video_url={nft8} nft_name="WING P #8"/>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6 col-12">
              <NFT_video video_url={nft9} nft_name="WING P #9"/>
            </div>
            <div className="col-lg-4 col-md-4 col-sm-6 col-12">
              <NFT_video video_url={nft10} nft_name="WING P #10"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}